import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { DatesService } from '@infrastructure/services/alpura/dates.service';

@Component({
  selector: 'app-select-week',
  templateUrl: './select-week.component.html',
  styleUrls: ['./select-week.component.scss'],
  providers: [DatesService],
})
export class SelectWeekComponent implements OnInit {
  @Output() updateWeek: EventEmitter<number> = new EventEmitter<number>();
  @Output() updateYear: EventEmitter<number> = new EventEmitter<number>();

  ListaSemanas: String[] = [];
  ListaAnios: any[] = [];

  public form: FormGroup = new FormGroup({
    week: new FormControl(null, Validators.required),
    year: new FormControl(null, Validators.required),
  });

  constructor(private datesService: DatesService) {
    this.form.get('year')?.valueChanges.subscribe((data) => {
      this.form.get('week')?.patchValue(null);
      if (!!data) this.fillWeeks(data);
      this.updateYear.emit(data);
    });

    this.form.get('week')?.valueChanges.subscribe((data) => {
      this.updateWeek.emit(data);
    });
  }

  ngOnInit(): void {
    this.fillYear();
  }


  fillYear() {
    this.ListaAnios = this.datesService.getYears();
  }

  getSemanaActual() {
    this.datesService.getCurrentWeek().subscribe((resp) => {
      const year = new Date().getFullYear();
      this.form.patchValue({
        week: resp,
        year: year,
      });
      this.updateWeek.emit(Number(resp));
      this.fillWeeks(year);
    });
  } 

  fillWeeks(year: number) {
    if (year) {
      this.datesService.getWeeksByYear(year).subscribe((response) => {
        this.ListaSemanas.length = 0;
        let i = 0;
        let semanas: any;

        semanas = response;
        for (i = 1; i <= semanas; i++) {
          this.ListaSemanas.push(i.toString());
        }
      });
    }
  }
}
